module.exports = __webpack_public_path__ + "img/boom.dfaa55c5.png";